import Vue from "vue";
import VueI18n from "vue-i18n";
import zn from "./zn";
import en from "./en";
Vue.use(VueI18n); // 全局注册国际化包

let userLanguage = "en";
if ("language" in navigator) {
  userLanguage = navigator.language.split("-")[0];
  localStorage.setItem("i18n", userLanguage);
} else {
  console.log("不支持获取系统语言");
}

// 准备翻译的语言环境信息
const i18n = new VueI18n({
  locale: userLanguage,
  messages: {
    zh: zn,
    en: en,
  },
});

export default i18n;
